import axios from 'axios'
import Vue from 'vue'

// const URL = 'https://sundrymarkets.website/api/'
// const URL = 'https://sundryfoods.website/api/'
const URL = 'https://wajehrapi.wajesmarthrms.website/api/'
export default {
    name: 'Request',
    makeGetRequest: (request) => {

        if (Vue.prototype.$store.getters.user_data !== null) {
            var user_data = Vue.prototype.$store.getters.user_data.data
        } else {
            var user_data = {
                company_id: 1,
                user_id: ""
            }
        }
        Vue.prototype.$swal.close()
        if (request.showLoader || request.showLoader == undefined) {
             var loading_html = `
      <div style="height:150px;width:150px;margin:0 auto;display:flex;align-items:center;justify-content:center;">
        <div style="
          width:48px;
          height:48px;
          border:4px solid #e5e5e5;
          border-top:4px solid #016734;
          border-radius:50%;
          animation: spin 0.8s linear infinite;
        "></div>
      </div>

      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;
            Vue.prototype.$swal.fire({
                title: "",
                html: loading_html,
                showConfirmButton: false,
                showCancelButton: false,
                allowOutsideClick: false
            })
        }

        var request_urls = {
            //openings: 'listappliedjobposting',
            openings: 'allopenings',
            questions: 'question',
            roles: 'jobroles',
            locations: 'joblocations',
            ListApplicants: 'listapplicants',
            Opening: 'findopening',
            GetStages: 'liststages',
            GetProcesses: 'listprocesses',
            ListRejectedOfferletter: 'listrejectedofferletter',
            CBT: 'cbt',
            ListCBT: 'listcbt',
            InterviewVideos: 'interviewvideo',
            DeleteApplicant: 'rppl',
            StarredApplications: 'starapplication',
            UnStarApplication: 'unstar',
            DiscontinuedApplications: 'alldeleted',
            GetHiringNote: 'hiringnotes',
            GetApplicant: 'getapplicant',
            GetSharedResumes: 'viewsharedresume',
            GetOfferTemplate: 'offertemplates',
            RecentApplications: 'recentappl',
            ScoreCardSections: 'sections',
            ScoreCardSectionFields: 'scorecardfields',
            ApplicantScorecard: 'listapplicantscorecard',
            PracticalEvaluationScores: 'listapplicantevaluationcard',
            DuplicateDetection: 'getpipelineforapplicant',
            GetApplicantCBT: 'getapplicantanswer',
            GetCBTRecording: 'cbtrecording',
            GetCBTRecordingComment: 'cbtRecordingComment',
            GetTopOpenings: 'getmostappliedjob',
            ReverseApplicantStage: 'recallapplicant',
            SearchResults: 'searchapplicant',
            RecentlyViewed: 'viewrecents',
            GetFinalNote: 'getfinalnote',
            GetOfferForRole: 'getofferforrole',
            GetOfferForApplicant: 'getofferforapplicant',
            GetOffer: 'viewjoboffer',
            GetUsers: 'allusers',
            GetRoles: 'getroles',
            GetCompanies: 'company',
            ProcessingApplicants: 'listfinalapplicants',
            listevaluators: 'listevaluator',
            listhiringmanager: 'listhiringmanager',
            listevaluatoratecard: 'listevaluatoratecard',
            getOpening: 'findopening',
            viewOpening: 'viewopening',
            getApplicantEmail: 'getApplicantEmail',
            getApplicants: 'getApplicants'
            
        }
        var c_str = "company_id=" + user_data.company_id + "&companyid=" + user_data.company_id + "&user_id=" + user_data.id
        if (request.params !== undefined) {
            var obj = request.params
            var str = Object.keys(obj).map((key) => { return key + '=' + obj[key] }).join('&')
            var request_url = URL + request_urls[request.what] + "?" + str + "&" + c_str
        } else {
            if (request.id !== undefined) {
                var request_url = URL + request_urls[request.what] + "/" + request.id + "?" + c_str
            } else {
                var request_url = URL + request_urls[request.what] + "?" + c_str
            }
        }
        console.log('%cSending get request to: ' + '%c' + request_url, 'color:#00ff00;font-size:14px;background:#000;', 'color:#ff0000;font-size:14px;background:#000;')
        return new Promise((resolve, reject) => {
            axios.get(request_url)
                .then((response) => {
                    Vue.prototype.$swal.close()
                    if (response.data.status == 'True' || response.data.status == true || response.data.status == 'true') {
                        var response = {
                            data: response.data.data,
                            counts: response.data.counts,
                            type: request.what,
                            status: 'true',
                            url: URL
                        }

                        resolve(response)

                    } else {
                        reject(response.data)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },

    makePostRequest: (request) => {

        if (Vue.prototype.$store.getters.user_data != null) {
            var user_data = Vue.prototype.$store.getters.user_data.data
        } else {
            var user_data = {
                company_id: 1,
                id: ""
            }
        }

        Vue.prototype.$swal.close()
        if (request.showLoader || request.showLoader == undefined) {
             var loading_html = `
      <div style="height:150px;width:150px;margin:0 auto;display:flex;align-items:center;justify-content:center;">
        <div style="
          width:48px;
          height:48px;
          border:4px solid #e5e5e5;
          border-top:4px solid #016734;
          border-radius:50%;
          animation: spin 0.8s linear infinite;
        "></div>
      </div>

      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;
            Vue.prototype.$swal.fire({
                title: "",
                html: loading_html,
                showConfirmButton: false,
                showCancelButton: false,
                allowOutsideClick: false
            })
        }
        var request_urls = {
            EditOpening: 'editOpening',
            login: 'login',
            AddOpening: 'openings',
            AddRole: 'jobroles',
            AddLocation: 'joblocations',
            AddQuestion: 'question',
            ApproveStage2: 'stg2ccept',
            CreateProcess: 'createprocess',
            AddCbt: 'cbt',
            AddQuestionToCbt: 'assigncbtquestions',
            StarApplication: 'starapplication',
            
            VideoUploadInstructions: 'interviewvideo',
            InterviewInformation: 'interviewgrant', //This also approves the Applicant for Stage 3 (Sublime saves every 59 words lol)
            FinalInterviewInformation: 'finalinterviewgrant', //This also approves the Applicant for Stage 3 (Sublime saves every 59 words lol)
            CreateHiringNote: 'hiringnotes',
            SendEmail: 'genericmail',
            ShareResume: 'shareresume',
            GetNoteForApplicant: 'evalsapplicant', //Should have been a GET request
            CreateOfferTemplate: 'offertemplates',
            CreateScoreCardSection: 'sections',
            CreateSectionField: 'sectiondetails',
            SendOfferLetter: 'extendoffer',
            PracticalEvaluation: 'sendtoevaluation',
            ScoreApplicant: 'rateapplicantcardscores',
            SubmitPracticalEvaluation: 'applicantevaluationcard',
            CbtToJoblisting: 'joblistingcbt',
            ForwardCV: 'forwardCV',
            MarkViewed: 'viewingapplication',
            RestoreDeletedApplicant: 'restoredeletedapplicant',
            CreateFinalNote: 'createfinalnote',
            ProgressApplicant: 'progressapplicant',
            NewRole: 'createrole',
            AddUser: 'register',
            RecruitToHR: 'uploadtohr',
            Assignevaluator: 'sendtoevaluation',
            EditUser: 'edituser',
            ForwardLetterToApplicant: 'forwardlettertoapplicant',
            cbtRecordingComment: 'cbtRecordingComment',
            UpdateRole: 'updateRole'
        }
        if (request.params !== undefined) {
            var obj = request.params
            var str = Object.keys(obj).map((key) => { return key + '=' + obj[key] }).join('&')
            var request_url = URL + request_urls[request.what] + "?" + str
        } else {
            var request_url = URL + request_urls[request.what]
        }

        if (request.url == undefined) {
            var request_url = URL + request_urls[request.what]
        } else {
            var request_url = request.url
        }

        if (request.headers !== undefined) {
            var config = {
                headers: request.headers
            }

        } else {
            var config = {

            }
        }
        var data = (request.data !== undefined) ? request.data : {}
        data.company_id = user_data.company_id
        data.companyid = user_data.company_id
        data.user_id = user_data.id
        console.log('%cSending post request to: ' + request_url, 'color:#00ff00;font-size:14px;background:#000;')
        console.log(data)
        return new Promise((resolve, reject) => {
            axios.post(request_url, data, config)
                .then((response) => {
                    Vue.prototype.$swal.close()
                    if (response.data.status == 'True' || response.data.status == true || response.data.status == 'true') {
                        response = {
                            data: response.data,
                            type: request.what,
                            status: 'true',
                            url: URL
                        }
                        resolve(response)
                    } else {
                        reject(response.data)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })

    },

    makeDeleteRequest: (request) => {
        var what = request.what
        var request_urls = {
            opening: 'openings',
            role: 'role',
            location: 'location',
            question: 'question',
            DeleteScoreCardSection: 'sections',
            DeleteSectionField: 'sectiondetails',
            DeleteUser: 'deleteUser',
            deleteCbtRecording: 'deletecbtrecording',
        }

        if (request.id !== undefined) {
            var request_url = URL + request_urls[what] + "/" + request.id
        }
        console.log('%cDeleting: ' + request_url, 'color:#00ff00;font-size:14px;background:#000;')
        return new Promise((resolve, reject) => {
            axios.delete(request_url)
                .then((response) => {
                    //console.log(response.data.success)
                    if (response.data.status == 'True' || response.data.status == true || response.data.status == 'true' || response.data.success == true) {
                        response = {
                            type: what,
                            status: 'true',
                            url: URL
                        }

                        resolve(response)
                    } else {
                        reject('Error')
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    makeEditRequest: (request) => {
        var what = request.what
        var request_urls = {
            EditRole: 'editrole',
            VideoUploadInstructions: 'interviewvideo',
            GetOfferTemplate: 'offertemplates',
            EditSectionField: 'sectiondetails',
            EditScoreCardSection: 'sections',
            EditOpening: 'editOpening',
            //EditUser: 'editrole',
        }
        if (request.id !== undefined) {
            var request_url = URL + request_urls[what] + "/" + request.id
        } else {
            var request_url = URL + request_urls[what]
        }
        console.log(request)
        console.log('%cSending put request: ', 'color:#fff;font-size:14px;background:#00ff00;')
        return new Promise((resolve, reject) => {
            axios.put(request_url, request.data)
                .then((response) => {
                    console.log(response)
                    if (response.data.status == 'True' || response.data.status == true || response.data.status == 'true' || response.data.success == true) {
                        response = {
                            type: what,
                            status: 'true',
                            data: response.data,
                            url: URL
                        }

                        resolve(response)
                    } else {
                        reject('Error')
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })

    },
}